export const markerStart = '<div><i class=\'iconfont icon-wuliusudi\' style=\'font-size:30px;\'></i></div>'
